import { useMutation, useQueryCache } from 'react-query';
import { TeamAPI } from 'api/admin/team';
import { TEAMS } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useUpdateTeam() {
  const queryCache = useQueryCache();

  return useMutation(TeamAPI.update, {
    onSuccess: ({ message }) => {
      dispatchToast({ message, type: 'success' });
      queryCache.invalidateQueries(TEAMS);
    },
  });
}
